module.exports = __webpack_public_path__ + "static/img/brand_logo_1.b11dff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_logo_1.png
// module id = wMwG
// module chunks = 1